/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import PluginCard from "../../ui/PluginCard";
import AddToCartControls from "../../AddToCartControls";

const ProductItem = React.memo(({ product, position, selectedProducts, handleProductSelect, updateProduct, reserveDescription = false, canEditQty = true, addedLabel }) => {
  const isSelected = selectedProducts?.find((s) => s.id === product.id);
  const inCart = Boolean(isSelected);

  const controls = (
    <AddToCartControls
      inCart={inCart}
      qty={isSelected?.qty || 0}
      canEditQty={canEditQty}
      addedLabel={addedLabel}
      onAdd={() => handleProductSelect(position, product)}
      onUpdate={(newQty) => updateProduct(position, product, newQty)}
      onRemove={() => handleProductSelect(position, product)}
    />
  );

  return (
    <PluginCard
      name={product.name}
      price={product.price}
      currency={product.currency}
      description={product.description}
      reserveDescription={reserveDescription}
      picture={product.picture_path}
      isSelected={inCart}
      footer={controls}
      modalFooter={controls}
    />
  );
});

export default ProductItem;
